import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography, Button } from '@mui/joy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate, useLocation } from 'react-router-dom';

function ThankYouPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const state = useLocation().state;
  const noCard = state?.noCard;
  let msg = 'subtitle';
  if (noCard) msg = 'noCard';
  if (state?.noPin) msg = 'noPin';
  return (
    <div className="p-4">
      <Stack direction="column" spacing={2} className="px-5">
        <Typography level="h2" textAlign="center">
          {t('thankYouPage.title')}
        </Typography>
        <div className="flex justify-center">
          <CheckCircleOutlineIcon sx={{ fontSize: 200 }} color="success" />
        </div>
        <Typography level="body-lg" textAlign="center">
          {t(`thankYouPage.${msg}`)}
        </Typography>
        <Button
          className="mt-4"
          variant="plain"
          color="primary"
          onClick={() => navigate('/')}
        >
          {t('thankYouPage.goToHome')}
        </Button>
      </Stack>
    </div>
  );
}

export default ThankYouPage;
